import Button from "./Button";

export default class SharedTurnsButton extends Button {
  setLeft: (this: SharedTurnsButton) => void = () => {};
  setCenter: (this: SharedTurnsButton) => void = () => {};
}
